module.exports = __webpack_public_path__ + "static/media/Thor.587d4adc.png";